"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _dayjs = _interopRequireDefault(require("../utils/dayjs"));
var _DateTimePicker = _interopRequireDefault(require("./DateTimePicker"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class DateTimeRangePicker extends _react.Component {
  static defaultProps = {
    useIcons: true,
    timeStep: 30,
    endTimeBump: 30,
    disableStartPast: true,
    disableEndPast: true,
    iconPosition: 'right'
  };
  constructor(props) {
    super(props);
    const {
      startId,
      endId,
      startDate,
      startTime,
      endDate,
      endTime,
      disableEndTimeBefore,
      startTooltipType,
      startTooltipMessage,
      endTooltipType,
      endTooltipMessage,
      tooltipPosition,
      updateTooltipPositionOnMove
    } = props;
    if (!startId || !endId) {
      throw new Error(`The props 'startId' and 'endId' are required to make DateTimeRangePicker accessible for users using assistive technologies such as screen readers. Check the render method of DateTimeRangePicker.`);
    }
    if (startTooltipType || startTooltipMessage || endTooltipType || endTooltipMessage || tooltipPosition || updateTooltipPositionOnMove) {
      throw new Error('Tooltip support inside of DateTimePicker was removed in v6.0.0. Use dateNode and timeNode getters in a parent component to add tooltips manually as necessary.');
    }
    this.state = {
      startDate,
      startTime,
      endDate,
      endTime,
      disableEndTimeBefore,
      addErrorClass: false,
      addHighlightClass: false,
      endKey: (0, _v.default)()
    };
  }
  componentDidMount() {
    this._checkInitialTimeDisabling();
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      onValid,
      onInvalid
    } = this.props;
    const {
      startDate,
      startTime,
      endDate,
      endTime,
      addHighlightClass
    } = this.state;
    const {
      startDate: prevStartDate,
      startTime: prevStartTime,
      endDate: prevEndDate,
      endTime: prevEndTime
    } = prevState;
    const startMoment = startDate && startTime ? this._getCombinedDate(startDate, startTime) : null;
    const endMoment = endDate && endTime ? this._getCombinedDate(endDate, endTime) : null;
    const validationState = {
      startDate,
      startTime,
      endDate,
      endTime,
      startMoment,
      endMoment,
      isEndDayBeforeStartDay: startMoment && endMoment && endMoment.isBefore(startMoment, 'day'),
      isEndTimeSameOrBeforeStartTime: startMoment && endMoment && endMoment.isSameOrBefore(startMoment, 'hour')
    };
    let isValid = true;
    if (addHighlightClass) {
      // if the previous state of the component included the highlight class remove it here
      // so that next time it needs to highlight it can be re-added and the animation plays
      this._clearHighlightTimeout();
      this._removeHighlightTimeout = setTimeout(() => {
        this.setState({
          addHighlightClass: false
        });
      }, 3000);
    }
    if (startDate && startTime && endDate && endTime) {
      if (startDate !== prevStartDate || startTime !== prevStartTime || endDate !== prevEndDate || endTime !== prevEndTime) {
        isValid = this._checkValidity();
      }
    }
    if (!isValid && onInvalid) {
      onInvalid(validationState);
    } else if (isValid && onValid) {
      onValid(validationState);
    }
  }
  componentWillUnmount() {
    this._clearHighlightTimeout();
  }
  _onStartChange = ({
    selectedDate,
    selectedTime
  }) => {
    const {
      onStartChange
    } = this.props;
    const {
      endDate,
      endTime
    } = this.state;
    const newData = {
      startDate: selectedDate,
      startTime: selectedTime,
      endDate,
      endTime
    };
    this.setState({
      startDate: selectedDate,
      startTime: selectedTime,
      ...this._getDisableEndTimeBefore(newData)
    });
    if (onStartChange) {
      onStartChange(newData);
    }
  };
  _onEndChange = ({
    selectedDate,
    selectedTime
  }) => {
    const {
      onEndChange
    } = this.props;
    const {
      startDate,
      startTime
    } = this.state;
    const newData = {
      startDate,
      startTime,
      endDate: selectedDate,
      endTime: selectedTime
    };
    this.setState({
      endDate: selectedDate,
      endTime: selectedTime,
      ...this._getDisableEndTimeBefore(newData)
    });
    if (onEndChange) {
      onEndChange(newData);
    }
  };
  _checkInitialTimeDisabling() {
    const {
      startDate,
      startTime,
      endDate,
      endTime
    } = this.state;
    const {
      disableEndTimeBefore,
      endKey
    } = this._getDisableEndTimeBefore({
      startDate,
      startTime,
      endDate,
      endTime
    });
    this.setState({
      disableEndTimeBefore,
      endKey
    });
  }
  _clearHighlightTimeout() {
    if (this._removeHighlightTimeout) {
      clearTimeout(this._removeHighlightTimeout);
    }
  }
  _getCombinedDate(date, time) {
    return (0, _dayjs.default)(`${date} ${time}`, 'MM/DD/YYYY hh:mm A');
  }
  _checkValidity() {
    const {
      autoBumpInvalidEnabled,
      endTimeBump,
      onEndChange
    } = this.props;
    const {
      startDate,
      startTime,
      endDate,
      endTime
    } = this.state;
    const start = this._getCombinedDate(startDate, startTime);
    const end = this._getCombinedDate(endDate, endTime);
    const newState = {
      addErrorClass: false,
      endDate,
      endTime
    };
    let isValid = true;
    if (end.isSameOrBefore(start)) {
      isValid = false;
      if (autoBumpInvalidEnabled) {
        isValid = true;
        const newEnd = start.add(endTimeBump, 'minute');
        newState.endDate = newEnd.format('MM/DD/YYYY');
        newState.endTime = newEnd.format('hh:mm A');
        newState.addHighlightClass = true;
        newState.endKey = (0, _v.default)();

        // check what times should be disabled based on newly selected values
        const {
          disableEndTimeBefore,
          endTime: newEndTime
        } = this._getDisableEndTimeBefore({
          startDate,
          startTime,
          endDate: newState.endDate,
          endTime: newState.endTime
        });
        newState.disableEndTimeBefore = disableEndTimeBefore;
        if (newEndTime) {
          newState.endTime = newEndTime;
        }
      } else {
        newState.addErrorClass = true;
      }
    }
    this.setState(newState);
    if (onEndChange) {
      onEndChange({
        startDate,
        startTime,
        endDate: newState.endDate,
        endTime: newState.endTime
      });
    }
    return isValid;
  }
  _getDisableEndTimeBefore({
    startDate,
    startTime,
    endDate,
    endTime
  }) {
    const {
      timeStep,
      endTimeBump,
      autoBumpInvalidEnabled,
      disableEndTimeBefore: propDisableEndTimeBefore
    } = this.props;
    const {
      disableEndTimeBefore,
      endKey
    } = this.state;
    const newState = {
      disableEndTimeBefore,
      endKey
    };
    if (startDate && startTime && endDate && endTime) {
      const start = this._getCombinedDate(startDate, startTime);
      const end = this._getCombinedDate(endDate, endTime);
      if (start.isSame(end, 'day')) {
        newState.disableEndTimeBefore = start.add(timeStep, 'minute').format('hh:mm A');
        newState.endKey = (0, _v.default)();
        if (start.isSameOrAfter(end, 'hour') && autoBumpInvalidEnabled) {
          // bump the end time because it will get bumped anyway due to the prior time not being in the list anymore
          newState.endTime = start.add(endTimeBump, 'minute').format('hh:mm A');
          newState.addHighlightClass = true;
        }
      } else if (newState.disableEndTimeBefore !== propDisableEndTimeBefore) {
        newState.disableEndTimeBefore = propDisableEndTimeBefore;
        newState.endKey = (0, _v.default)();
      }
    }
    return newState;
  }

  /**
   * Getter for the start date time picker.
   *
   * @public
   * @returns {Element} - The component reference.
   */
  get startDateTime() {
    return this._startDateTime;
  }

  /**
   * Getter for the end date time picker.
   *
   * @public
   * @returns {Element} - The component reference.
   */
  get endDateTime() {
    return this._endDateTime;
  }
  render() {
    const {
      className,
      startId,
      endId,
      useIcons,
      iconPosition,
      startDateLabel,
      startTimeLabel,
      endDateLabel,
      endTimeLabel,
      startDateName,
      startTimeName,
      endDateName,
      endTimeName,
      timeStep,
      separator,
      disableStartPast,
      disableStartDateBefore,
      disableStartDateAfter,
      disableStartTimeBefore,
      disableStartTimeAfter,
      disableEndPast,
      disableEndDateBefore,
      disableEndDateAfter,
      disableEndTimeAfter,
      disableStartDateTimePicker,
      disableEndDateTimePicker,
      areAllFieldsEmpty,
      useTetherShim,
      startDateDisplayFormat,
      startTimeDisplayFormat,
      endDateDisplayFormat,
      endTimeDisplayFormat
    } = this.props;
    const {
      startDate,
      startTime,
      endDate,
      endTime,
      addErrorClass,
      disableEndTimeBefore,
      endKey,
      addHighlightClass
    } = this.state;
    const classes = (0, _classnames.default)('DateTimeRangePicker', className);
    const startClasses = (0, _classnames.default)('DateTimePicker-start', {
      'DateTimePicker-error': areAllFieldsEmpty
    });
    const endClasses = (0, _classnames.default)('DateTimePicker-end', {
      'DateTimePicker-highlight': addHighlightClass
    }, {
      'DateTimePicker-error': addErrorClass || areAllFieldsEmpty
    });
    const newDisableEndDateBefore = startDate ? startDate : disableEndDateBefore;
    let overrideInitialEndMonthWithSelected = true;

    // if the end picker has a date disabled whose month is after the end selected date, make sure the calendar starts with the first selectable month
    if (endDate && newDisableEndDateBefore) {
      const end = (0, _dayjs.default)(endDate);
      const endBeforeMoment = (0, _dayjs.default)(newDisableEndDateBefore);
      overrideInitialEndMonthWithSelected = end.isAfter(endBeforeMoment);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement(_DateTimePicker.default, {
      ref: node => {
        this._startDateTime = node;
      },
      id: startId,
      dateName: startDateName,
      timeName: startTimeName,
      className: startClasses,
      calendarClassName: "calendar-start",
      useIcons: useIcons,
      iconPosition: iconPosition,
      dateLabel: startDateLabel,
      timeLabel: startTimeLabel,
      timeStep: timeStep,
      selectedDate: startDate,
      selectedTime: startTime,
      dateDisplayFormat: startDateDisplayFormat,
      timeDisplayFormat: startTimeDisplayFormat,
      onChange: this._onStartChange,
      disablePast: disableStartPast,
      disableDateBefore: disableStartDateBefore,
      disableDateAfter: disableStartDateAfter,
      disableTimeBefore: disableStartTimeBefore,
      disableTimeAfter: disableStartTimeAfter,
      useTetherShim: useTetherShim,
      datePlaceholder: "Start Date",
      timePlaceholder: "Start Time",
      disabled: disableStartDateTimePicker
    }), separator, /*#__PURE__*/_react.default.createElement(_DateTimePicker.default, {
      key: endKey,
      ref: node => {
        this._endDateTime = node;
      },
      id: endId,
      dateName: endDateName,
      timeName: endTimeName,
      className: endClasses,
      calendarClassName: "calendar-end",
      useIcons: useIcons,
      iconPosition: iconPosition,
      dateLabel: endDateLabel,
      timeLabel: endTimeLabel,
      timeStep: timeStep,
      selectedDate: endDate,
      selectedTime: endTime,
      dateDisplayFormat: endDateDisplayFormat,
      timeDisplayFormat: endTimeDisplayFormat,
      overrideInitialMonthWithSelected: overrideInitialEndMonthWithSelected,
      onChange: this._onEndChange,
      disablePast: disableEndPast,
      disableDateBefore: newDisableEndDateBefore,
      disableDateAfter: disableEndDateAfter,
      disableTimeBefore: disableEndTimeBefore,
      disableTimeAfter: disableEndTimeAfter,
      useTetherShim: useTetherShim,
      datePlaceholder: "End Date",
      timePlaceholder: "End Time",
      disabled: disableEndDateTimePicker
    }));
  }
}
exports.default = DateTimeRangePicker;